import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalModule } from './components/modal/modal.module';

import { AdminService, AuthService, NotificationsService, RolesService, UtilsService } from './services';

import { ConfirmModalComponent } from './components/confirm.modal/confirm.modal.component';
import { PinModalComponent } from './components/pin.modal/pin.modal.component';

import { IsProcessingComponent } from './components/isprocessing/isprocessing.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MobileBottomTabsComponent } from './components/mobile-bottom-tabs/mobile-bottom-tabs.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PaginatorComponent } from './components/paginator/paginator.component';

import { MemberService } from './services/member.service';
import { StorageService } from './services/storage.service';
import { AllocationService } from './services/allocation.service';
import { FilterPipe, supportDatePipe } from "./pipes/filter.pipe";


@NgModule({
  declarations: [
    LoaderComponent,
    PaginatorComponent,
    IsProcessingComponent,
    ConfirmModalComponent,
    MobileBottomTabsComponent,
    NavbarComponent,
    FilterPipe,
    PinModalComponent,
    supportDatePipe
  ],
  exports: [
    LoaderComponent,
    PaginatorComponent,
    MobileBottomTabsComponent,
    NavbarComponent,
    ConfirmModalComponent,
    PinModalComponent,
    IsProcessingComponent,
    FilterPipe,
		supportDatePipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ModalModule
  ],
  providers: [
    AdminService,
    AuthService,
    MemberService,
    NotificationsService,
    RolesService,
    StorageService,
    UtilsService,
    AllocationService
  ]
})
export class SharedModule { }